import './shop-swiper.scss';
import 'react-id-swiper/src/styles/scss/swiper.scss';
import React from 'react';
import Swiper from 'react-id-swiper';
import AdSwiper from './ad-swiper';
import HttpsProtocolImage from '../common/https-protocol-image.jsx';

class ShopSwiper extends React.Component {
  constructor(props) {
    super(props);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
  }

  onTouchStart() {
    this.mySwiper.stopAutoplay();
  }

  onTouchEnd() {
    setTimeout(() => {
      this.mySwiper.startAutoplay();
    }, 500);
  }

  render() {
    // 处理图片高度
    const { imgSize } = this.props;
    const imgHeight = (imgSize === 0) ? '37.4vw' : '130px';
    const shopImgs = this.props.shopIntroImgs.map((item, index) => {
      if (imgSize === undefined) {
        return (
          <div key={index} className="o-pl o-pr o-pt o-pb">
            <HttpsProtocolImage src={item.link} alt="" style={{ height: imgHeight }} />
          </div>
        );
      }
      if (imgSize === 0) {
        return (
          <div key={index} className="o-pl o-pr o-pt o-pb">
            <a href={item.url} style={{ background: '#fff' }}>
              <HttpsProtocolImage src={item.imgUrl} alt="" style={{ height: imgHeight }} />
            </a>
          </div>
        );
      }
      return true;
    });

    // 获取图片数量 根据图片数量判断是否显示.swiper-pageination
    const showNav = ((this.props.shopIntroImgs).length === 1) ? '.swiper-pagination .dis-none' : '.swiper-pagination';
    // 通过 resize 事件避免 swiper 不能正确加载的 bug
    // 有待改进
    const event = document.createEvent('HTMLEvents');
    event.initEvent('resize', true, true);
    document.dispatchEvent(event);

    // imgSize === 1  堂食 外卖轮播广告
    return imgSize === 1 ?
      <AdSwiper
        imgList={this.props.shopIntroImgs}
        autoplay={3500}
      /> :
      <div className="shop-swiper">
        <Swiper
          pagination={showNav}
          paginationClickable
          autoplay={2500}
          onTouchStart={this.onTouchStart}
          onTouchEnd={this.onTouchEnd}
          onInit={swiper => this.mySwiper = swiper}
          loop={this.props.shopIntroImgs.length > 1}
        >
          {shopImgs}
        </Swiper>
      </div>;
  }
}

ShopSwiper.propTypes = {
  shopIntroImgs: React.PropTypes.array,
  imgSize: React.PropTypes.number,
};

export default ShopSwiper;



// WEBPACK FOOTER //
// ./src/component/shop-home/shop-swiper.jsx